class ProductInfo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.initDragState()
  }

  initDragState () {
    // Initialize drag state variables
    this.dragState = {
      isDown: false,
      startX: 0,
      scrollLeft: 0,
      hasDragged: false, // Add flag to track if user actually dragged
    }
  }

  setupListeners () {
    super.setupListeners()

    this.handleTabChange = this.handleTabChange.bind(this)
    this.handleMouseDown = this.handleMouseDown.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.handleMouseUp = this.handleMouseUp.bind(this)
    this.handleMouseMove = this.handleMouseMove.bind(this)

    // Tab click listeners
    this.externalEls.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTabChange)
    })
    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTabChange)
    })

    // Mouse drag listeners for tabs container
    const tabsContainer = this.els.tabs.element
    const amountOfTabs = this.els.trigger?.elements.length

    if (tabsContainer && amountOfTabs > 2) {
      // Only run the JS if the container needs scrolling
      tabsContainer.style.cursor = 'grab'
      tabsContainer.style.userSelect = 'none'

      this.listeners.add(tabsContainer, 'mousedown', this.handleMouseDown)
      this.listeners.add(tabsContainer, 'mouseleave', this.handleMouseLeave)
      this.listeners.add(tabsContainer, 'mouseup', this.handleMouseUp)
      this.listeners.add(tabsContainer, 'mousemove', this.handleMouseMove)
    }
  }

  handleMouseDown (event) {
    const container = event.currentTarget
    this.dragState.isDown = true
    this.dragState.hasDragged = false // Reset drag flag on each mouse down
    this.dragState.startX = event.pageX - container.offsetLeft
    this.dragState.scrollLeft = container.scrollLeft
    container.style.cursor = 'grabbing'
  }

  handleMouseLeave () {
    this.dragState.isDown = false
    const container = this.querySelector('.drw-ProductInfoHeader_Tabs')
    if (container) {
      container.style.cursor = 'grab'
    }
  }

  handleMouseUp () {
    this.dragState.isDown = false
    const container = this.querySelector('.drw-ProductInfoHeader_Tabs')
    if (container) {
      container.style.cursor = 'grab'
    }
  }

  handleMouseMove (event) {
    if (!this.dragState.isDown) return

    event.preventDefault()
    this.dragState.hasDragged = true // Set flag when user actually drags
    const container = event.currentTarget
    const x = event.pageX - container.offsetLeft
    const walk = (x - this.dragState.startX) * 2 // Multiply by 2 for faster scrolling
    container.scrollLeft = this.dragState.scrollLeft - walk
  }

  handleTabChange (event) {
    const clickedTrigger = event.target

    // Check if this was actually a drag operation
    if (this.dragState.hasDragged) {
      this.dragState.hasDragged = false // Reset for next interaction
      return
    }

    this.els.trigger?.elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.tab === clickedTrigger.dataset.tab,
      )
    })

    this.els.panel?.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.tab !== clickedTrigger.dataset.tab,
      )
    })

    // Find the corresponding internal trigger to scroll into view
    const correspondingInternalTrigger = this.els.trigger?.elements.find(
      (triggerEl) => triggerEl.dataset.tab === clickedTrigger.dataset.tab,
    )

    if (correspondingInternalTrigger) {
      this.scrollTabIntoView(correspondingInternalTrigger)
    }
  }

  scrollTabIntoView (tabElement) {
    const tabsContainer = this.els.tabs.element

    if (!tabsContainer || !tabElement) {
      console.error('Missing container or tab element')
      return
    }

    // Always center the clicked tab for best visibility
    const containerRect = tabsContainer.getBoundingClientRect()
    const tabRect = tabElement.getBoundingClientRect()

    // Calculate the position to center the tab in the container
    const tabCenter =
      tabRect.left +
      tabRect.width / 2 -
      containerRect.left +
      tabsContainer.scrollLeft
    const containerCenter = containerRect.width / 2
    const targetScrollLeft = tabCenter - containerCenter

    tabsContainer.scrollTo({
      left: Math.max(0, targetScrollLeft),
      behavior: 'smooth',
    })
  }
}

if (!customElements.get('product-info')) {
  customElements.define('product-info', ProductInfo)
}
